import { render, staticRenderFns } from "./mBuzzer.vue?vue&type=template&id=c24b4758&scoped=true"
import script from "./mBuzzer.vue?vue&type=script&lang=js"
export * from "./mBuzzer.vue?vue&type=script&lang=js"
import style0 from "./mBuzzer.vue?vue&type=style&index=0&id=c24b4758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24b4758",
  null
  
)

export default component.exports